import { css } from "twin.macro";

export * from "./colors";
export * from "./zIndex";

export const radialGradientCss = css({
  background: "radial-gradient(circle at top, #FF4CE1, #FF9892)",
});
